import {Registered} from '@/Manager';
import {Match} from './Match';
import {TATHelper} from '@/Helper/TATHelper';
import manager from '@/Manager/Manager';
import {Player} from '@/models/Player';
import playerStore from '@/stores/modules/player';
import {DoubletteHelper} from '@/Helper/DoubletteHelper';

export enum GameMode {
	TETE_A_TETE,
	DOUBLETTE,
	TRIPLETTE,
}

export class Game extends Registered {
	
	private _equipeFixe: boolean = false;
	private _mode: GameMode = GameMode.DOUBLETTE;
	private _started: boolean = false;
	
	private _matchs: Match[] = [];
	
	
	public get matchs(): Match[] {
		return this._matchs;
	}
	
	public addMatch(match: Match): this {
		this._matchs.push(match);
		return this;
	}
	
	public get equipeFixe(): boolean {
		return this._equipeFixe;
	}
	
	public get mode(): GameMode {
		return this._mode;
	}
	
	public get started(): boolean {
		return this._started;
	}
	
	public set equipeFixe(value: boolean) {
		this._equipeFixe = value;
	}
	
	public set mode(value: GameMode) {
		this._mode = value;
	}
	
	public set started(value: boolean) {
		this._started = value;
	}
	
	public createMatch() {
		switch (this.mode) {
			case GameMode.TETE_A_TETE:
				TATHelper.matchNJ(this);
				break;
			case GameMode.DOUBLETTE:
				DoubletteHelper.matchNJ(this);
				break;
			case GameMode.TRIPLETTE:
				// TripletteteHelper.matchNJ(this);
				break;
			
		}
	}
	
	public nbMatchPlayedByPlayer(player: Player): number {
		return this._matchs.filter(m => {
			for (let i = 0; i < m.equipes.length; i++) {
				if (m.hasPlayer(i, player) && m.isJouer(i)) {
					return true;
				}
			}
			return false;
		}).length;
	}
	
	public totalScoreByPlayer(player: Player): number {
		let total = 0;
		this._matchs.forEach(m => {
			for (let i = 0; i < m.equipes.length; i++) {
				total += m.score(i, player);
			}
			return false;
		});
		return total;
	}
	
	public nbMatchWinByPlayer(player: Player): number {
		return this._matchs.filter(m => {
			for (let i = 0; i < m.equipes.length; i++) {
				if (m.hasPlayer(i, player) && m.isWin(i, player)) {
					return true;
				}
			}
			return false;
		}).length;
	}
	
	public minNbMatchPlayedByPlayer(player: Player): boolean {
		const current = this.nbMatchPlayedByPlayer(player);
		const players = playerStore.state.players;
		for(const p of players) {
			if (this.nbMatchPlayedByPlayer(p) < current) {
				return false
			}
		}
		return true;
	}
	
	public minTotalScoreByPlayer(player: Player): boolean {
		const current = this.totalScoreByPlayer(player);
		const players = playerStore.state.players;
		for(const p of players) {
			if (this.totalScoreByPlayer(p) < current) {
				return false
			}
		}
		return true;
	}
	
	public minNbMatchWinByPlayer(player: Player): boolean {
		const current = this.nbMatchWinByPlayer(player);
		const players = playerStore.state.players;
		for(const p of players) {
			if (this.nbMatchWinByPlayer(p) < current) {
				return false
			}
		}
		return true;
	}
	
	public maxNbMatchPlayedByPlayer(player: Player): boolean {
		const current = this.nbMatchPlayedByPlayer(player);
		const players = playerStore.state.players;
		for(const p of players) {
			if (this.nbMatchPlayedByPlayer(p) > current) {
				return false
			}
		}
		return true;
	}
	
	public maxTotalScoreByPlayer(player: Player): boolean {
		const current = this.totalScoreByPlayer(player);
		const players = playerStore.state.players;
		for(const p of players) {
			if (this.totalScoreByPlayer(p) > current) {
				return false
			}
		}
		return true;
	}
	
	public maxNbMatchWinByPlayer(player: Player): boolean {
		const current = this.nbMatchWinByPlayer(player);
		const players = playerStore.state.players;
		for(const p of players) {
			if (this.nbMatchWinByPlayer(p) > current) {
				return false
			}
		}
		return true;
	}
	
	public toJSON(): any {
		return {
			__className__: 'Game',
			mode: this._mode,
			equipeFixe: this._equipeFixe,
			started: this._started,
			matchs: this._matchs.map(m => m.id),
		};
	}
	
	public fromJSON(data: any): this {
		this._mode = data.mode;
		this._equipeFixe = data.equipeFixe;
		this._started = data.started;
		this._matchs = <Match[]>data.matchs.map(id => manager.find(id));
		return this;
	}
	
	public register(): void {
		this._matchs.forEach(m => {
			manager.register(m);
			m.register();
		});
	}
}
